const participationStatusLabels: Record<string, string> = {
  NOT_STARTED: "Não iniciada",
  IN_PROGRESS: "Em andamento",
  COMPLETED: "Concluída",
  CANCELLED: "Cancelada",
  BLOCKED: "Bloqueada",
};

const certificateStatusLabels: Record<string, string> = {
  NOT_AVAILABLE: "Não disponível",
  AVAILABLE: "Disponível",
  ISSUED: "Emitido",
  REVOKED: "Revogado",
  BLOCKED: "Bloqueado",
};

export const participationStatusLabel = (status?: string): string =>
  participationStatusLabels[String(status || "").toUpperCase()] || status || "Não informada";

export const certificateStatusLabel = (status?: string): string =>
  certificateStatusLabels[String(status || "").toUpperCase()] || status || "Não informado";
